<script setup lang="ts">

import type { IOfferTile } from "@domain/Marketplace";
import { OfferHeaderStyle } from "../../Types/OfferHeaderStyle";

type Props =
{
    offer: IOfferTile,
    headerStyle?: OfferHeaderStyle
};

const { offer, headerStyle = OfferHeaderStyle.Large } = defineProps<Props>();
const hasNotice = offer.isEndingSoon || offer.isRecentlyAdded;

</script>

<template>

    <div class="flex flex-col w-full
                tracking-wider leading-tight"
         :class="{ 
            'bg-gray-800 px-2 py-2.5 3xl:px-4 3xl:py-3 text-sm 3xl:text-base': headerStyle == OfferHeaderStyle.Small,
            'bg-gray-800 px-3 py-3 3xl:px-4 3xl:py-4 text-base 3xl:text-xl': headerStyle == OfferHeaderStyle.Medium,
            'bg-gray-800 px-4 py-4 3xl:px-4 3xl:py-5 text-base lg:text-lg 3xl:text-xl': headerStyle == OfferHeaderStyle.Large,
            'px-4 py-6 3xl:px-6 3xl:py-6 text-lg lg:text-xl 3xl:text-3xl': headerStyle == OfferHeaderStyle.Full,
            'bg-gradient-to-b from-gray-850 to-transparent': headerStyle == OfferHeaderStyle.Full
         }">

        <div v-if="hasNotice && headerStyle == OfferHeaderStyle.Full"
             class="flex flex-col text-sm uppercase -mx-6 3xl:mb-4 3xl:text-base text-fuchsia-300
                    bg-gradient-to-b from-transparent via-50% via-fuchsia-500/10 to-transparent rounded-md -mt-4 pt-2 pb-4 3xl:pt-4">

            <!-- OFFER ENDS SOON -->
            <div v-if="offer.isEndingSoon"
                    class="flex justify-center lg:tracking-widest">
                <span><span class="hidden lg:inline">Check availability, </span>offer ends soon*</span>
            </div>

            <!-- RECENTLY ADDED -->
            <div v-else-if="offer.isRecentlyAdded"
                 class="flex justify-center lg:tracking-widest">
                Recently added
            </div>

        </div>
            
        <div class="font-bold leading-tight"
             :class="{ 
                'truncate': headerStyle != OfferHeaderStyle.Full 
             }">
            {{ offer.advertiserName }}
        </div>

        <div class="text-[0.8em] leading-tight"
             :class="{ 
                'truncate': headerStyle != OfferHeaderStyle.Full ,
                'text-secondary-400': !offer.isGiftCard && offer.isAutomotive,
                'text-orange-400':!offer.isGiftCard && offer.isLifestyle,
                'text-[#3f7beb]': offer.isGiftCard
             }">
            {{ offer.title }}
        </div>
        
        <!-- BOOKABLE INDICATOR -->
        <div v-if="headerStyle == OfferHeaderStyle.Large && offer.hasBookingLink" 
             class="flex items-center tracking-wider
                    text-[0.8em] leading-tight
                    gap-1 pt-px"
             :class="{
                'text-secondary-400': !offer.isGiftCard && offer.isAutomotive,
                'text-orange-400': !offer.isGiftCard && offer.isLifestyle,
                'text-[#3f7beb]': offer.isGiftCard
             }">
            Bookings Available
            <Icon name="calendar" class="text-lg pt-px" />
        </div>
        
    </div>

</template>
